import { xApplyFunctionStr } from 'ml-spectra-processing';
/**
 * Filter that allows to
 * @param data
 * @param options
 */
export function yFunction(data, options = {}) {
    return {
        data: {
            x: data.x,
            y: xApplyFunctionStr(data.y, {
                variableLabel: 'y',
                fctString: options.function,
            }),
        },
    };
}
//# sourceMappingURL=yFunction.js.map